/**
 * CUSTOMER-R4.15-K31 — invisible build identity on <html> dataset only.
 * Never paint deploy/release/hash in Customer UI.
 */
import { useEffect, useState } from "react";

export const CUSTOMER_RELEASE =
  (import.meta.env.VITE_CUSTOMER_RELEASE as string | undefined)?.trim() ||
  (String(import.meta.env.VITE_BUILD_ID ?? "").includes("R4-15-E")
    ? "R4.15-E"
    : String(import.meta.env.VITE_BUILD_ID ?? "").includes("R4-15-D")
      ? "R4.15-D"
      : "");

/** Apply canonical build metadata on <html> for runtime proof. */
export function applyCustomerBuildIdentityDataset(buildId: string, release: string): void {
  try {
    document.documentElement.dataset.buildId = buildId;
    document.documentElement.dataset.release = release || CUSTOMER_RELEASE || "unknown";
  } catch {
    /* ignore */
  }
}

export function OwnerBuildIdentityChipV2({ buildId }: { buildId: string }) {
  // Keep E hook order; never paint identity in the tree.
  const [, setReady] = useState(false);
  useEffect(() => {
    applyCustomerBuildIdentityDataset(buildId, CUSTOMER_RELEASE);
    setReady(true);
  }, [buildId]);
  return null;
}
